export default "__VITE_ASSET__4cd06974__"